export const accountInformationCompleted = () => ({
  type: 'Account Information Completed',
});
